import React, { useEffect, useState } from "react";

import { Icon, IconTypeEnum } from "../icon";

import "./styles.scss";

const ScrollToTopButton: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const scrollToTop = () => {
    const header = document.querySelector("header");
    if (header) {
      header.scrollIntoView({ behavior: "smooth" });
    }
  };
  useEffect(() => {
    const handleScroll = () => {
      const scrollY = Math.max(window.scrollY, document.body.scrollTop);
      setIsVisible(scrollY > 0);
    };
    document.body.addEventListener("scroll", handleScroll);
    window.addEventListener("scroll", handleScroll);

    return () => {
      document.body.removeEventListener("scroll", handleScroll);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  if (!isVisible) return null;

  return (
    <button
      className={`scroll-to-top-btn ${isVisible ? "scroll-to-top-btn--visible" : ""}`}
      type="button"
      onClick={scrollToTop}
      aria-label="Прокрутить вверх"

    >
      <Icon className="scroll-to-top-btn__icon" type={IconTypeEnum.Right} />
    </button>
  );
};

export default ScrollToTopButton;
